import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import NotificationServices from "./NotificationServices";

const initialState = {
  notifications: [],
  notification: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};
export const getNotification = createAsyncThunk(
  "notification/getNotification",
  async (_, thunkAPI) => {
    try {
      return await NotificationServices.getNotification();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteNotification = createAsyncThunk(
  "notification/deleteNotification",
  async (id, thunkAPI) => {
    try {
      return await NotificationServices.deleteNotification(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteAllNotifications = createAsyncThunk(
  "notification/deleteAllNotifications",
  async (_, thunkAPI) => {
    try {
      return await NotificationServices.deleteAllNotifications();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    RESET_NOTIFICATION(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getNotification.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.notifications = action.payload;
      })

      .addCase(getNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(deleteNotification.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.notification = action.payload;
      })

      .addCase(deleteNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(deleteAllNotifications.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteAllNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.notifications = [];
      })

      .addCase(deleteAllNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      });
  },
});

export const { RESET_NOTIFICATION } = notificationSlice.actions;
export const selectNotifications = (state) => state.notification.notifications;

export default notificationSlice.reducer;
